import { useLocaleStore } from '@/stores/locale';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { en } from './en';
import { zhCN } from './zh-CN';

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    'zh-CN': { translation: zhCN },
  },
  lng: useLocaleStore.getState().lang,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

useLocaleStore.subscribe((state, prev) => {
  if (state.lang !== prev.lang) void i18n.changeLanguage(state.lang);
});

export default i18n;
